import api from "../../../config/axios/configAxios";
import i18next from "i18next";
import { ShortLangToEnum } from "../../../features/common/converters/language";

export const getReasons = async () => api.get(`/api/Dictionaries/list`);

export const getReasonsById = async (key: string, id: string) =>
  api.get(`/api/Dictionaries/${id}/values?langId=${ShortLangToEnum(i18next.language)}`);

// Values as stored in the database (untranslated) - use them when a value is sent back to the API
export const getReasonsSourceValuesById = async (key: string, id: string) =>
  api.get(`/api/Dictionaries/${id}/values`);

export const addReason = async({id, value}: any) => api.post(`/api/Dictionaries/${id}/add-value`, {value});

export const deleteReasonById = async (id: string) => api.delete(`/api/Dictionaries/${id}/remove-value`);

export const editReason = async({id, value}: any) => api.put(`/api/Dictionaries/${id}/update-value`, {value});